import styles from "./home.module.css";

const Panner = () => {
  return (
    <div className={styles.panner}>
      <h2>
        Focus On Your <span>Fitness</span> Not Your Loss
      </h2>
    </div>
  );
};

export default Panner;
